{
  "title": "Turismo",
  "lead": "Mga pasyalan, trail, pista, at mga accredited na gabay at homestay.",
  "adminTitle": "Turismo",
  "adminLead": "Mga pasyalan, trail at pagpaparehistro ng bisita, mga gabay at homestay, at estadistika ng mga bisita.",
  "noCapability": "Hindi humahawak ng turismo ang opisinang ito. Tanungin ang administrator kung dapat itong idagdag.",
  "tab_spots": "Mga pasyalan",
  "tab_trails": "Mga trail",
  "tab_visits": "Mga bisita sa trail",
  "tab_directory": "Gabay at homestay",
  "tab_stats": "Estadistika",
  "status_open": "Bukas",
  "status_temporarily_closed": "Pansamantalang sarado",
  "status_closed": "Sarado",
  "difficulty_easy": "Madali",
  "difficulty_moderate": "Katamtaman",
  "difficulty_challenging": "Mahirap",
  "visit_booked": "Nakarehistro",
  "visit_checked_in": "Naka-check in",
  "visit_cancelled": "Kinansela",
  "visit_no_show": "Hindi dumating",
  "checkin_checked_in": "Naka-check in na",
  "checkin_already": "Naka-check in na kanina",
  "checkin_not_found": "Walang nahanap na tiket",
  "checkin_cancelled": "Kinansela na ang rehistrong ito",
  "checkin_wrong_day": "Tiket para sa ibang araw",
  "period_month": "Buong buwan",
  "period_day": "Isang araw",
  "lastVerified": "Huling sinuri ng {office} noong {date}",
  "notVerifiedYet": "Hindi pa nasusuri sa lugar ng Tourism Office.",
  "staleNote": "Mahigit anim na buwan na mula nang suriin ito. Maaaring nagbago ang oras at bayad; tumawag muna kung kaya.",
  "guideRequired": "Kailangan ng gabay",
  "registrationOpen": "Bukas ang rehistro",
  "photosOf": "Mga larawan ng {name}",
  "photoN": "Larawan {n} {name}",
  "trailhead": "Simula ng trail",
  "legend": "Paliwanag sa mapa",
  "legendTrail": "Trail",
  "legendAccess": "Daan papunta sa simula ng trail",
  "myTickets": "Mga trail ticket mo sa teleponong ito",
  "groupOf": "Grupo ng {count}",
  "emptyTitle": "Wala pang nailalathalang pasyalan o trail",
  "emptyBody": "Ililista dito ng Tourism Office ang mga pasyalan at trail.",
  "spotsTitle": "Mga pasyalan",
  "trailsTitle": "Mga trail",
  "trailsLead": "Ang mga trail lang na nasuri ng Tourism Office sa mismong lugar ang nakalista. Iparehistro ang grupo bago pumunta.",
  "eventsTitle": "Mga pista at kaganapan",
  "eventsEmpty": "Walang paparating na pista o kaganapan na naipost.",
  "seeCalendar": "Tingnan ang lahat ng kaganapan sa kalendaryo",
  "directoryTitle": "Mga gabay at homestay",
  "directoryLead": "Mga accredited na tour guide at homestay",
  "directoryEmptyShort": "Wala pang nailistang accredited na gabay o homestay ang Tourism Office.",
  "directoryPageLead": "Accredited ng Tourism Office. Nawawala sa listahan kapag napaso na ang accreditation.",
  "directoryEmpty": "Wala pang nakalistang accredited na gabay o homestay",
  "directoryEmptyBody": "Magtanong sa Tourism Office tungkol sa mga accredited na gabay at matutuluyan.",
  "directoryNote": "Direktang makipag-ayos sa mga gabay at homestay. Hindi tumatanggap ang LGU ng booking o bayad para sa kanila.",
  "guidesTitle": "Mga tour guide",
  "homestaysTitle": "Mga homestay",
  "noGuidesListed": "Walang nakalistang accredited na gabay.",
  "noHomestaysListed": "Walang nakalistang accredited na homestay.",
  "accreditedUntil": "Accreditation {no} · balido hanggang {date}",
  "accreditationNo": "Accreditation {no}",
  "languages": "Wika: {list}",
  "servesTrails": "Mga trail:",
  "capacity": "Hanggang {count} bisita",
  "email": "Email",
  "call": "Tumawag",
  "backToTourism": "Turismo",
  "spotNotFound": "Hindi nakalista ang lugar na ito",
  "trailNotFound": "Hindi nakalista ang trail na ito",
  "ticketNotFound": "Hindi namin mahanap ang trail ticket na iyan",
  "shareText": "Ibinahagi mula sa {app}",
  "closedNoNote": "Magtanong muna sa Tourism Office bago pumunta.",
  "visitInfo": "Pagbisita",
  "hours": "Oras ng pagbubukas",
  "fees": "Bayad",
  "notStated": "Hindi nakasaad. Magtanong sa Tourism Office.",
  "howToGetThere": "Paano pumunta",
  "mapOf": "Mapa kung nasaan ang {name}",
  "getDirections": "Kumuha ng direksyon",
  "noDirections": "Wala pang nailalagay na direksyon.",
  "wasteRules": "Mga patakaran sa basura",
  "wasteDefault": "Iuwi ang inyong basura. Huwag mag-iwan ng bakas.",
  "trailsHere": "Mga trail dito",
  "trailMapOf": "Mapa ng {name}: ang trail, ang daan papunta sa simula nito, at ang simula ng trail",
  "verifiedLine": "Linya ng trail mula sa {source}, sinuri noong {date}.",
  "offlineHint": "Buksan muna ang pahinang ito habang may signal: nakatabi sa telepono ang mapa at ang iyong tiket.",
  "rules": "Mga patakaran sa trail",
  "guidesForTrail": "Mga accredited na gabay para sa trail na ito",
  "noRegistration": "Hindi bukas ang rehistro para sa trail na ito.",
  "chooseDay": "Araw ng inyong pagbisita",
  "dayFull": "Puno na",
  "dayOpen": "Bukas",
  "slotsLeft": "{count} na lang",
  "bookTitle": "Iparehistro ang grupo",
  "bookLead": "Hanggang {cap} bisita bawat araw. Isang rehistro bawat grupo; ipapakita ng lider ang QR code sa simula ng trail.",
  "guestNote": "Hindi kailangan ng account. May account ka na?",
  "groupSize": "Bilang ng tao",
  "guide": "Gabay",
  "guideRequiredHint": "Kailangan ng accredited na gabay sa trail na ito.",
  "chooseGuide": "Pumili ng gabay",
  "noGuide": "Walang gabay",
  "noGuidesYet": "Kailangan ng gabay sa trail na ito, pero wala pang nakalistang accredited na gabay. Magtanong sa Tourism Office.",
  "leaderName": "Buong pangalan ng lider ng grupo",
  "mobile": "Numero ng mobile",
  "mobileHint": "Para sa mga pagbabago o emergency habang nasa trail.",
  "book": "Magparehistro",
  "booking": "Nagpaparehistro…",
  "chooseDayError": "Pumili ng araw.",
  "nameError": "Ilagay ang pangalan ng lider ng grupo.",
  "mobileError": "Ilagay ang numero ng mobile.",
  "guideError": "Pumili ng gabay.",
  "consentError": "Pakisang-ayunan ang abiso sa privacy.",
  "checkForm": "Pakisuri ang mga naka-highlight na bahagi.",
  "ticketTitle": "Trail ticket",
  "ticketEyebrow": "Trail ticket",
  "bookedTitle": "Nakarehistro na kayo",
  "bookedBody": "Ipakita ang QR code na ito sa simula ng trail. Nakatabi ito sa telepono, kaya bubukas kahit walang signal.",
  "offlineCopy": "Walang signal: ipinapakita ang kopyang nakatabi sa teleponong ito.",
  "qrAlt": "QR code para sa trail ticket {code}",
  "ticketCodeLabel": "Code ng tiket {code}",
  "date": "Petsa",
  "leader": "Lider ng grupo",
  "checkedInAt": "Naka-check in",
  "ticketHint": "Isang tiket para sa buong grupo. Dumating nang sabay-sabay sa simula ng trail.",
  "cancelVisit": "Kanselahin ang pagbisitang ito",
  "cancelTitle": "Kanselahin ang pagbisitang ito?",
  "cancelBody": "Mapupunta sa ibang bisita ang inyong mga puwesto. Puwede kayong magparehistro ulit kung may bakante pa.",
  "cancelYes": "Oo, kanselahin",
  "cancelKeep": "Huwag na",
  "cancelledToast": "Nakansela na ang inyong pagbisita.",
  "manageNote": "Ang telepono o account lang na nagparehistro ang makakakita ng contact details o makakapagkansela.",
  "addSpot": "Magdagdag ng pasyalan",
  "editSpot": "I-edit ang pasyalan",
  "noSpotsStaff": "Wala pang pasyalan",
  "noSpotsStaffBody": "Idagdag ang mga lugar na itinatanong ng mga bisita: oras, bayad, paano pumunta at mga patakaran sa basura.",
  "hidden": "Nakatago",
  "markVerified": "Nasuri ngayon",
  "verifiedToast": "Naitalang nasuri ngayong araw.",
  "viewPublic": "Tingnan ang pampublikong pahina",
  "savedToast": "Nai-save.",
  "fieldName": "Pangalan",
  "nameRequired": "Maglagay ng pangalan (hindi bababa sa 2 titik).",
  "fieldSummary": "Maikling buod",
  "fieldSummaryHint": "Isa o dalawang pangungusap na makikita sa card.",
  "fieldDescription": "Paglalarawan",
  "fieldPhotos": "Mga larawan",
  "fieldPhotosHint": "Ang unang larawan ang cover. Pinapaliit ang mga larawan sa telepono.",
  "fieldPin": "Lokasyon sa mapa",
  "fieldAccessibility": "Accessibility",
  "fieldWasteHint": "Ano ang dapat gawin ng mga bisita sa kanilang basura dito.",
  "fieldStatus": "Katayuan",
  "fieldStatusNote": "Paliwanag tungkol sa pagsasara",
  "fieldOrder": "Pagkakasunod",
  "fieldOrderHint": "Mas maliit na numero ang nauuna.",
  "fieldActive": "Ipakita sa publiko",
  "coverPhoto": "Cover na larawan",
  "moveEarlier": "Iusog pauna",
  "moveLater": "Iusog pahuli",
  "uploading": "Ina-upload…",
  "trailsStaffLead": "Ilathala lang ang trail kung may linya itong nasuri ng opisina sa mismong lugar (GPS track o beripikadong survey) at ang petsa ng pagsusuri.",
  "addTrail": "Magdagdag ng trail",
  "editTrail": "I-edit ang trail",
  "noTrailsStaff": "Wala pang trail",
  "noTrailsStaffBody": "Magdagdag ng trail na may beripikadong linya ng GPS, mga patakaran at limit ng bisita bawat araw.",
  "published": "Nailathala",
  "draft": "Draft",
  "todayCount": "Ngayon {count} / {cap}",
  "notVerifiedTrail": "Wala pang beripikadong linya ng trail, kaya hindi pa ito mailalathala.",
  "fieldSpot": "Pasyalan",
  "noSpot": "Hindi nakakabit sa pasyalan",
  "fieldDifficulty": "Hirap",
  "fieldDuration": "Karaniwang tagal",
  "fieldDurationHint": "Halimbawa: 2–3 oras balikan.",
  "verifiedDataTitle": "Beripikadong datos ng trail",
  "verifiedDataLead": "Mag-upload ng GeoJSON na linya (LineString) sa longitude, latitude. Gamitin lang ang mga linyang nasuri ng opisina; huwag gumuhit ng trail mula sa hula.",
  "fieldTrailLine": "Linya ng trail",
  "fieldTrailLineHint": "GeoJSON file na ang trail ay isang linya.",
  "fieldAccessLine": "Daan papunta sa simula ng trail",
  "fieldAccessLineHint": "Opsyonal na GeoJSON na linya mula sa pinakamalapit na kalsada hanggang sa simula ng trail.",
  "fieldSource": "Pinagmulan ng linya",
  "fieldSourceHint": "Sino ang nag-survey, hal. \"GPS survey ng Tourism Office\".",
  "fieldVerifiedOn": "Nasuri sa lugar noong",
  "previewMap": "Silip sa mga na-upload na linya",
  "fieldTrailhead": "Lokasyon ng simula ng trail",
  "fieldGuideRequired": "Kailangang may accredited na gabay ang mga bisita",
  "fieldRegistration": "Buksan ang rehistro ng bisita",
  "fieldDailyCap": "Limit ng bisita bawat araw",
  "fieldDailyCapHint": "Kabuuang bisita bawat araw, lahat ng grupo.",
  "fieldPublished": "Ilathala ang trail na ito",
  "capRequired": "Itakda muna ang limit ng bisita bawat araw bago buksan ang rehistro.",
  "publishNeedsVerified": "Para mailathala, idagdag ang linya ng trail, ang pinagmulan nito at ang petsa ng pagsusuri.",
  "chooseFile": "Pumili ng file",
  "replaceFile": "Palitan ang file",
  "linesLoaded": "{count} linya ang na-load",
  "geojsonTooBig": "Masyadong malaki ang file. Pasimplehin ang linya (bawasan ang mga punto) at subukan ulit.",
  "geojsonTooManyPoints": "Masyadong maraming punto ang linya. Pasimplehin muna ito.",
  "geojsonInvalid": "Hindi magagamit ang file na ito: {error}",
  "trail": "Trail",
  "allTrails": "Lahat ng trail",
  "checkInTitle": "Mag-check in sa simula ng trail",
  "checkIn": "I-check in",
  "checkInError": "Hindi ma-check in",
  "offlineCheckIn": "Walang koneksyon. Tingnan ang tiket sa telepono ng grupo at subukan ulit pagbalik ng signal.",
  "typeCode": "O i-type ang code ng tiket",
  "cameraView": "Camera para sa pag-scan ng tiket",
  "startCamera": "I-scan ang QR code",
  "stopCamera": "Itigil ang camera",
  "cameraDenied": "Na-block ang camera. Payagan ito sa settings ng browser, o i-type ang code.",
  "cameraError": "Hindi mabuksan ang camera. I-type na lang ang code ng tiket.",
  "totalGroups": "Mga grupo",
  "totalVisitors": "Mga bisita",
  "totalCheckedIn": "Naka-check in",
  "totalNoShow": "Hindi dumating",
  "exportCsv": "I-export ang CSV",
  "noVisits": "Walang bisita sa trail sa araw na ito",
  "checkedInAtTime": "Naka-check in nang {time}",
  "markNoShow": "Hindi dumating",
  "undo": "Ibalik",
  "addGuide": "Magdagdag ng gabay",
  "editGuide": "I-edit ang gabay",
  "noGuidesStaff": "Wala pang gabay",
  "expired": "Napaso na",
  "addHomestay": "Magdagdag ng homestay",
  "editHomestay": "I-edit ang homestay",
  "noHomestaysStaff": "Wala pang homestay",
  "homestayListedRule": "Lumalabas lang sa publiko ang homestay kung may numero ng accreditation at hindi pa lumilipas ang petsa ng bisa nito.",
  "notAccredited": "Walang nailagay na accreditation",
  "listed": "Nakalista",
  "notListed": "Hindi nakalista",
  "accreditationRequired": "Ilagay ang numero ng accreditation.",
  "untilRequired": "Ilagay ang petsa ng pagtatapos ng accreditation.",
  "fieldAccreditationNo": "Numero ng accreditation",
  "fieldAccreditedUntil": "Accredited hanggang",
  "fieldAccreditedUntilHint": "Itatago sa publiko ang gabay pagkalipas ng petsang ito.",
  "fieldLanguages": "Mga wika",
  "fieldLanguagesHint": "Paghiwalayin ng kuwit, hal. English, Filipino, Ilocano.",
  "fieldTrailsServed": "Mga trail na ginagabayan",
  "fieldPhone": "Telepono",
  "fieldGuidePhoto": "Larawan",
  "fieldNotes": "Mga tala",
  "fieldNotesHint": "Makikita ng publiko.",
  "fieldAddress": "Address",
  "fieldCapacity": "Bilang ng bisita",
  "homestayAccreditationHint": "Kailangan para lumabas sa publiko ang homestay.",
  "from": "Mula",
  "to": "Hanggang",
  "rangeHint": "Iwanang blangko para sa nakaraang 12 buwan.",
  "enterCount": "Maglagay ng bilang ng bisita",
  "enterCountLead": "Para sa isang lugar, isang araw o buong buwan. Kapag inilagay ulit ang parehong lugar at panahon, papalitan ang naunang bilang. Ang bilang para sa buong buwan ang gagamitin sa kabuuan sa halip na ang mga bilang bawat araw sa buwang iyon.",
  "place": "Lugar",
  "otherPlaces": "Iba pang lugar / lahat",
  "periodType": "Bilang para sa",
  "monthField": "Buwan",
  "monthFieldHint": "Kahit anong araw sa buwan.",
  "dayField": "Araw",
  "totalVisitorsField": "Kabuuang bisita",
  "totalRequired": "Ilagay ang kabuuang bilang ng bisita.",
  "residents": "Taga-rito",
  "nonResidents": "Hindi taga-rito",
  "foreign": "Dayuhan",
  "saveCount": "I-save ang bilang",
  "countSaved": "Nai-save ang bilang.",
  "enteredVisitors": "Mga bisita (inilagay na bilang)",
  "trailVisitors": "Mga bisita sa trail (naka-check in)",
  "statsRange": "{from} hanggang {to}",
  "exportStats": "I-export para sa ulat sa DOT (CSV)",
  "chartByMonth": "Mga bisita bawat buwan (inilagay na bilang)",
  "chartTrailByMonth": "Mga bisita sa trail bawat buwan (naka-check in)",
  "chartByPlace": "Mga bisita bawat lugar",
  "visitors": "Mga bisita",
  "showTable": "Ipakita ang talahanayan",
  "hideTable": "Ipakita ang tsart",
  "noData": "Walang nabilang na bisita sa panahong ito.",
  "colPeriodPlace": "Buwan o lugar",
  "enteredCounts": "Mga inilagay na bilang",
  "noCounts": "Walang inilagay na bilang para sa panahong ito",
  "colPeriod": "Panahon",
  "colSplit": "Hati",
  "deleteCount": "Burahin ang bilang na ito",
  "myVisits": "Aking mga pagbisita sa trail"
}
